
































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";

@Component
export default class RadioGroupDialog extends Vue {
  @Prop({ default: "【タイトル】" }) title!: string;
  @Prop({ default: "OK" }) buttonOk!: string;
  @Prop({ default: "キャンセル" }) buttonCancel!: string;
  @Prop({ default: () => ["選択１", "選択２", "選択３"] }) labels!: string[];
  @Prop({ default: () => [] }) disableLabels!: number[];

  //出力タイプ
  private index = 0;

  //開いているかどうか
  private isActive = false;

  //開く
  public open(idx: number | null) {
    // idxがnullの場合は、値をセットし直さない
    if (idx != null) {
      if (this.labels.length <= idx) {
        idx = 0;
      }
      this.index = idx;
    }
    this.isActive = true;
  }

  //決定
  @Emit()
  private selected() {
    this.isActive = false;
    return this.index;
  }

  //キャンセル
  private cancel() {
    this.isActive = false;
  }
}
